import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import { SubProductGroupActions, SubProductGroupStore, STATUS } from 'Stores/subProductGroupStore'

export default class SubProductGroupList extends Component {
  constructor(props) {
    super(props)
    this.stores = [SubProductGroupStore]
    this.storeKeys = ['subProductGroups', 'status']
  }

  componentDidMount() {
    SubProductGroupActions.getSubProductGroups()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching Sub Product Groups Failed', {
        autoClose: 7500,
        onClose: () => {
          SubProductGroupActions.clearToast()
        }
      })
      SubProductGroupActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Delete Sub Product Group Failed', {
        autoClose: 7500,
        onClose: () => {
          SubProductGroupActions.clearToast()
        }
      })
      SubProductGroupActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('Sub Product Group Deleted', {
        autoClose: 7500,
        onClose: () => {
          SubProductGroupActions.clearToast()
        }
      })
      SubProductGroupActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <CollapsibleCard startOpen header={<strong>Sub Product Groups</strong>}>
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'SubProductGroupID'
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup style={{ float: 'right' }}>
                    <Tooltip target={'edit' + e.SubProductGroupID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/subProductGroups/' + e.SubProductGroupID} id={'edit' + e.SubProductGroupID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Tooltip target={'delete' + e.SubProductGroupID}>Slet</Tooltip>
                    <Button
                      id={'delete' + e.SubProductGroupID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Vil du slette denne Sub Product Group?')) {
                          SubProductGroupActions.deleteSubProductGroup(e.SubProductGroupID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            SubProductGroupID: 'ID',
            SubProductGroupName: 'Navn'
          }}
          data={this.state.subProductGroups}
        />
      </CollapsibleCard>
    )
  }
}
